import { render, staticRenderFns } from "./RecordingUsageTrackingTable.vue?vue&type=template&id=35fa3dbc&"
import script from "./RecordingUsageTrackingTable.vue?vue&type=script&lang=js&"
export * from "./RecordingUsageTrackingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports